// Muss als erstes Modul in Potree.js importiert werden: Einstellungen an three, die greifen
// müssen, bevor andere Module Farben oder Texturen anlegen.

import * as THREE from "../libs/three.js/build/three.module.js";

// three >= r152 rechnet Farben standardmäßig sRGB -> linear um und kodiert am Ende zurück.
// Potree schreibt Punktfarben roh über eigene Shader; damit Messlinien, Beschriftungen und
// Hintergrund weiterhin so aussehen wie mit r124, bleibt das Farbmanagement aus
// (renderer.outputColorSpace wird in viewer.initThree passend auf Linear gesetzt).
THREE.ColorManagement.enabled = false;

// three bringt seit r160 keinen globalen UMD-Build mehr mit. Potree bündelt three ohnehin ein;
// site.js und Fremdbibliotheken (z.B. das LCC-Web-SDK als UMD) greifen über window.THREE darauf zu.
// Als flache Kopie: Rollup friert Namespace-Objekte ein, das alte globale three.js war aber
// beschreibbar (Erweiterungen wie THREE.MeshLine hängen sich dort ein).
if (typeof window !== 'undefined' && window.THREE === undefined) {
	window.THREE = Object.assign({}, THREE);
}

export { THREE };
